import { useContext, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import PageSpinner from "../../components/global/pageSpinner"
import EditContainer from "../../components/global/editContainer"
import EditHeading from "../../components/global/editHeading"
import { MainContext } from "../../controllers/main"
import { CircularProgress, Grow } from "@mui/material"
import { TeamsContext } from "../../controllers/teams"
import { ChannelsContext } from "../../controllers/channels"

const TeamReportNew = () => {
  const { animation, setAnimation, showPadding } = useContext(MainContext)
  const { preChangesCurrentTeam, getCurrentTeam } = useContext(TeamsContext)
  const { channelsList } = useContext(ChannelsContext)
  const navigate = useNavigate()
  const { teamId } = useParams()

  // loading
  const [loading, setLoading] = useState<boolean>(true)

  // page error
  const [pageError, setPageError] = useState<boolean>(false)

  // fetch team if missing
  const fetchTeam = async () => {
    if (!preChangesCurrentTeam) {
      const noErrors = await getCurrentTeam(teamId)
      if (noErrors) {
        setLoading(false)
      } else {
        setPageError(true)
      }
    } else {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchTeam()
  }, [])

  // iframe loading
  const [iframeLoading, setIframeLoading] = useState<boolean>(true)

  return loading ? (
    <PageSpinner
      showBackButton={pageError}
      backButtonOnClick={() => {
        navigate(
          window.location.pathname.slice(
            0,
            window.location.pathname.indexOf("/report")
          )
        )
      }}
    />
  ) : (
    <EditContainer>
      <EditHeading
        backButtonOnClick={() => {
          setAnimation(false)
          setTimeout(() => {
            navigate(
              window.location.pathname.slice(
                0,
                window.location.pathname.indexOf("/report")
              )
            )
          }, 300)
        }}
        title={preChangesCurrentTeam.name + " / Report"}
        id={preChangesCurrentTeam.id}
      />
      <Grow in={animation} timeout={350}>
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <iframe
            style={{
              width: "calc(100% - 280px)",
              height:
                showPadding === "yes"
                  ? "calc(100vh - 152px)"
                  : "calc(100vh - 134px)",
              overflow: "hidden",
              margin: showPadding === "yes" ? "16px" : 0,
              marginTop: 0,
              border: "none",
              borderRadius: 4,
            }}
            onLoad={() => {
              setIframeLoading(false)
            }}
            src={
              channelsList.some((channel) => channel.teamId === teamId)
                ? "https://lookerstudio.google.com/embed/reporting/17124892-9598-440f-8315-467a3e6f73ba/page/T2kdD?params=" +
                  encodeURI(
                    JSON.stringify({
                      "ds348.team_id": teamId,
                      "ds346.team_id": teamId,
                      "ds340.team_id": teamId,
                      "ds347.team_id": teamId,
                      "ds139.team_id": teamId,
                      "ds176.team_id": teamId,
                      "ds172.team_id": teamId,
                      "ds170.team_id": teamId,
                      "ds173.team_id": teamId,
                      "ds171.team_id": teamId,
                      "ds138.team_id": teamId,
                      "ds341.team_id": teamId,
                      "ds140.team_id": teamId,
                      "ds137.team_id": teamId,
                      "ds470.team_id": teamId,
                      "ds248.team_id": teamId,
                    })
                  )
                : "https://lookerstudio.google.com/embed/reporting/93af0cac-0725-4c8a-bf8b-421918092ce3/page/T2kdD?params=" +
                  encodeURI(
                    JSON.stringify({
                      "ds348.team_id": teamId,
                      "ds346.team_id": teamId,
                      "ds340.team_id": teamId,
                      "ds347.team_id": teamId,
                      "ds139.team_id": teamId,
                      "ds176.team_id": teamId,
                      "ds172.team_id": teamId,
                      "ds170.team_id": teamId,
                      "ds173.team_id": teamId,
                      "ds171.team_id": teamId,
                      "ds138.team_id": teamId,
                      "ds341.team_id": teamId,
                      "ds140.team_id": teamId,
                      "ds137.team_id": teamId,
                      "ds470.team_id": teamId,
                      "ds248.team_id": teamId,
                    })
                  )
            }
          />
          {iframeLoading && (
            <CircularProgress style={{ position: "absolute" }} />
          )}
        </div>
      </Grow>
    </EditContainer>
  )
}

export default TeamReportNew
